import { Component } from 'react';

// eslint-disable-next-line import/no-cycle
import WishForm from './allocationWish/WishForm';

class Allocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null
    };
  }

  handleAllocationWish = (e) => {
    e.preventDefault();
    this.setState({
      modal: 'AllocationWish'
    });
  };

  handleCloseModal = () => {
    this.setState({
      modal: null
    });
  };

  render() {
    const { allocation, product } = this.props;
    const { modal } = this.state;
    return (
      <>
        <div className="c7-allocation" key={allocation.allocationId}>
          <div className="c7-allocation__title">{allocation.title}</div>
          <div className="c7-allocation__quantity">
            <span>Allocated Quantity: </span>{' '}
            {renderAllocatedQuantity(allocation)}
            {allocation.additionalGrant > 0 && (
              <>
                <br />
                <span>Additional Granted: </span> {allocation.additionalGrant}
              </>
            )}
          </div>
          {allocation.wishQuantity > 0 && (
            <div className="c7-allocation__wish">
              <span>Wish Quantity: </span> {allocation.wishQuantity}
            </div>
          )}
          {allocation.quantityPurchased > 0 && (
            <div className="c7-allocation__prev">
              <span>Prev Purchased: </span> {allocation.quantityPurchased}
            </div>
          )}
          <div className="c7-allocation__request">
            <a onClick={this.handleAllocationWish}>Request More &raquo;</a>
          </div>
        </div>
        {renderModal(modal, this.handleCloseModal, allocation, product)}
      </>
    );
  }
}

const renderAllocatedQuantity = (allocation) => {
  if (allocation.minQuantity !== allocation.maxQuantity) {
    return (
      <>
        {allocation.minQuantity} - {allocation.maxQuantity}
      </>
    );
  }
  return allocation.minQuantity;
};

const renderModal = (modal, handleCloseModal, allocation, product) => {
  switch (modal) {
    case 'AllocationWish': {
      return (
        <WishForm
          onCloseModal={handleCloseModal}
          allocation={allocation}
          product={product}
        />
      );
    }
    default: {
      return null;
    }
  }
};

export default Allocation;
